/**
 * WhatsApp support utility
 * Shared helper for opening WhatsApp support from anywhere in the app
 */

import { Linking } from 'react-native';
import { analytics, AnalyticsEvent } from './analytics';

const WHATSAPP_NUMBER = process.env.EXPO_PUBLIC_WHATSAPP_NUMBER || '+33760025005';

/**
 * Open WhatsApp with a pre-filled support message
 * @param context Optional context string appended to the message for support triage
 */
export function openWhatsAppSupport(context?: string) {
  const baseMessage = "Bonjour, j'ai besoin d'aide sur l'app Wealfi.";
  const fullMessage = context ? `${baseMessage}\n\nContexte : ${context}` : baseMessage;
  const encoded = encodeURIComponent(fullMessage);
  const cleanNumber = WHATSAPP_NUMBER.replace(/[^0-9]/g, '');
  const url = `https://wa.me/${cleanNumber}?text=${encoded}`;

  analytics.trackEvent(AnalyticsEvent.WHATSAPP_FAB_CLICKED);
  Linking.openURL(url);
}
